<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Editar tarea</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Atrás</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <base-input
                label="Descripción"
                prepend-icon="fas fa-desktop"
                v-model="tarea.descripcion"
              />
              <validation-error :errors="apiValidationErrors.nombre" />
              <base-input
                label="Fecha"
                type="date"
                v-model="tarea.fecha"
                placeholder="Fecha"
              />

              <base-input label="Tipo de tarea">
                <el-select
                  name="empresa"
                  v-model="tarea.tipo_tarea.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="tipo in available_tipos"
                    :key="tipo.id"
                    :value="tipo.id"
                    :label="tipo.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>

              <validation-error :errors="apiValidationErrors.empresa" />

              <base-input label="Planta a revisar">
                <el-select
                  name="empresa"
                  v-model="tarea.empresa.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="empresa in available_empresas"
                    :key="empresa.id"
                    :value="empresa.id"
                    :label="empresa.alias"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.empresa" />

              <base-input label="Revisor">
                <el-select
                  name="revisor"
                  v-model="tarea.revisor.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="revisor in available_revisores"
                    :key="revisor.id"
                    :value="revisor.id"
                    :label="revisor.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.revisor" />

              <base-input label="Estado de la tarea">
                <el-select
                  name="empresa"
                  v-model="tarea.estado_tarea.id"
                  prepend-icon="fas fa-user"
                >
                  <el-option
                    v-for="estado in available_estados"
                    :key="estado.id"
                    :value="estado.id"
                    :label="estado.nombre"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <validation-error :errors="apiValidationErrors.estado" />

              <div class="my-4">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Actualizar tarea
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mixins: [formMixin],

  data() {
    return {
      available_tipos: [],
      available_empresas: [],
      available_revisores: [],
      available_estados: [],

      tarea: {
        type: "tareas",
        descripcion: null,
        fecha: null,
        tipo_tarea: {
          id: null,
        },
        empresa: {
          id: null,
        },
        revisor: {
          id: null,
        },
        estado_tarea: {
          id: null,
        },
      },
    };
  },

  created() {
    this.getEmpresas();
    this.getTipos();
    this.getRevisores();
    this.getEstados();
    this.get();
  },

  watch: {
    /*  color: {
      handler: "updateTagColor",
      immediate: true,
      deep: true,
    }, */
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("tareas/get", id);
        this.tarea = this.$store.getters["tareas/tarea"];
        console.log(this.tarea);

        this.tarea.empresa.id = this.tarea.empresa.data.id;
        this.tarea.tipo_tarea.id = this.tarea.tipo_tarea.data.id;
        this.tarea.revisor.id = this.tarea.revisor.data.id;
        this.tarea.estado_tarea.id = this.tarea.estado_tarea.data.id;
        this.tarea.fecha =
          this.tarea.fecha != null ? this.tarea.fecha.substring(0, 10) : null;

        console.log(this.tarea);
        /*   if (this.asset.imagen.data) {
          this.image = this.asset.imagen.data[0].attributes.url;
        }
        console.log(this.asset);
        console.log(this.image); */
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    checkIdRevisor(id) {
      return this.available_revisores.some(function (gfg) {
        return gfg.id === id;
      });
    },
    async handleSubmit() {
      console.log(this.tarea);

      try {
        await this.$store.dispatch("tareas/update", this.tarea);
        this.$notify({
          type: "success",
          message: "Tarea actualizada correctamente.",
        });
        this.goBack();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error al actualizar la tarea",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async getEmpresas() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });
        console.log(meEmpresas);
        this.$store.dispatch("empresas/list").then(() => {
          var empresas = cloneDeep(this.$store.getters["empresas/dropdown"]);

          empresas.forEach((element) => {
            if (meEmpresas.includes(element.id)) {
              this.available_empresas.push(element);
            }
            //
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getTipos() {
      try {
        this.$store.dispatch("tiposTarea/list").then(() => {
          this.available_tipos = cloneDeep(
            this.$store.getters["tiposTarea/dropdown"]
          );
          this.available_tipos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getRevisores() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });

        this.$store.dispatch("users/list").then(() => {
          var usuarios = cloneDeep(this.$store.getters["users/dropdown"]);

          usuarios.forEach((element) => {
            element.empresas.forEach((empresa) => {
              if (meEmpresas.includes(empresa.id)) {
                if (this.available_revisores.length == 0) {
                  this.available_revisores.push(element);
                }

                if (!this.checkIdRevisor(element.id)) {
                  console.log("ENTRA");
                  this.available_revisores.push(element);
                }
              }
            });
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getEstados() {
      try {
        this.$store.dispatch("estadosTarea/list").then(() => {
          this.available_estados = cloneDeep(
            this.$store.getters["estadosTarea/dropdown"]
          );
          this.available_estados.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
